import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common'; // Required for *ngIf, *ngFor
import { ReactiveFormsModule } from '@angular/forms'; // Required for [formGroup]
import { SurfSearchBannerComponent } from './surf-search-banner/surf-search-banner.component';



@NgModule({
  declarations: [
    SurfSearchBannerComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  exports: [
    SurfSearchBannerComponent
  ]
})
export class SurfSearchBannerModule { }
